/**
 * @param {*} state
 */
export const jadlogAgencies = state => state.jadlogAgencies

/**
 * @param {*} state
 */
export const states = state => state.states

/**
 * @param {*} state
 */
export const pagination = state => state.pagination

/**
 * @param {*} state
 */
export const filters = state => state.filters

/**
 * @param {*} state
 */
export const modalOpenFlag = state => state.modalOpenFlag

/**
 * @param {*} state
 */
export const sidebarOpen = state => state.sidebarOpen
